import { Suspense } from 'react';

import { ModelFile, ModelLayer } from '../model-context/ModelContext.ts';
import { LayerSetting } from '../project-settings/types.ts';
import { GLTFModel } from './GLTFModel.tsx';
import { ModelPlaceholder } from './ModelPlaceholder.tsx';
import { OBJModel } from './OBJModel.tsx';

interface ModelLoaderProps {
  model: ModelFile;
  position: [number, number, number];
  onHover: (name: string | null) => void;
  onClick: (name: string) => void;
  isHovered: boolean;
  onLayersFound?: (modelName: string, layers: ModelLayer[]) => void;
  visibleLayers?: string[];
  isHoveredName: string | null;
  selectedLayer?: string | null;
  layerSettings: LayerSetting[];
  isLoaded?: boolean;
}

// Component to render the appropriate model based on file extension
export function ModelLoader({
  model,
  position,
  onHover,
  onClick,
  isHovered,
  onLayersFound,
  visibleLayers,
  isHoveredName,
  selectedLayer,
  layerSettings,
  isLoaded,
}: ModelLoaderProps) {
  const extension = model.name.split('.').pop()?.toLowerCase();

  if (!model.url) {
    return (
      <ModelPlaceholder
        name={model.name}
        position={position}
        onHover={onHover}
        onClick={onClick}
        isHovered={isHovered}
      />
    );
  }

  return (
    <Suspense
      fallback={
        <ModelPlaceholder
          name={model.name}
          position={position}
          onHover={onHover}
          onClick={onClick}
          isHovered={isHovered}
        />
      }
    >
      {extension === 'glb' && (
        <GLTFModel
          url={model.url}
          name={model.name}
          isHoveredName={isHoveredName}
          selectedLayer={selectedLayer}
          layerSettings={layerSettings}
          position={position}
          onHover={onHover}
          onClick={onClick}
          isHovered={isHovered}
          onLayersFound={onLayersFound}
          visibleLayers={visibleLayers}
          isLoaded={isLoaded}
        />
      )}
      {extension === 'obj' && (
        <OBJModel
          url={model.url}
          name={model.name}
          isHoveredName={isHoveredName}
          selectedLayer={selectedLayer}
          position={position}
          onHover={onHover}
          onClick={onClick}
          isHovered={isHovered}
          onLayersFound={onLayersFound}
          visibleLayers={visibleLayers}
          layerSettings={layerSettings}
          isLoaded={isLoaded}
        />
      )}
    </Suspense>
  );
}
